import _ from 'lodash';
import dynamic from 'next/dynamic';
import { APP_IMG, NEXT_DAILYMOTION_ID } from 'src/constants';
import styled from 'styled-components';
const Image = dynamic(import('src/components/image'));

// export const getFeatureImage = (_data, _options = false) => {
//   if (!_data) return null;
//   // console.log(_options ? 'NONE_OPTION' : 'ss');
//   const chechOption = _options && 'NONE_OPTION';
//   let urlVideo = '';
//   if (_data?.is_video && _data?.type_video !== null) {
//     if (_data?.type_video === '0') {
//       urlVideo = `${APP_IMG}/${_data?.video_src}`;
//     } else {
//       urlVideo = `${_data?.video_src}`;
//     }
//     return (
//       <div className='embed-responsive'>
//         <iframe src={`${urlVideo}?autoplay=1`} />
//       </div>
//     );
//   }
//   return <Image image={_data?.image} title={_data?.title} ignoreLazy={false} type={chechOption} />;
// };

export const getFeatureImage = (_data, _options = false, _showImg = false) => {
  if (_.isEmpty(_data)) return null;
  const chechOption = _options && 'NONE_OPTION';
  if (_showImg) {
    return <Image image={_data?.image} title={_data?.title} ignoreLazy={false} type={chechOption} />;
  }
  switch (_data?.type_video) {
    case '0':
      return (
        <EmbdedWrapper className='embed-responsive embed-responsive-16by9'>
          <iframe src={`${`${APP_IMG}/${_data?.video_src}`}?autoplay=1`} />
        </EmbdedWrapper>
      );
    case '1': // dailymotion
      return (
        <EmbdedWrapper>
          <div
            className='embed-dailymotion'
            dangerouslySetInnerHTML={{
              __html: `
              <script
              type='text/javascript'
              src='${NEXT_DAILYMOTION_ID}'
              data-video=${_data?.video_src}
              ></script>`
            }}
          />
        </EmbdedWrapper>
      );
    case '2': // youtube url
      return (
        <EmbdedWrapper className='embed-responsive embed-responsive-16by9'>
          <iframe src={`${_data?.video_src}?autoplay=1`} />
        </EmbdedWrapper>
      );

    default:
      return <Image image={_data?.image} title={_data?.title} ignoreLazy={false} type={chechOption} />;
  }
};

const EmbdedWrapper = styled.div`
  position: relative;
  .embed-dailymotion {
    width: 100%;
    aspect-ratio: 16 / 9;
    display: flex;
    align-items: center;
    justify-content: center;
    .dailymotion-player-root {
      position: unset !important;
    }
    .resolution-video,
    .resolution-dailymotion {
      width: 100%;
      height: 100%;
    }
  }
  &.embed-responsive-16by9 {
    width: 100%;
    aspect-ratio: 16 / 9;
    iframe {
      aspect-ratio: 16 / 9;
      height: 100% !important;
    }
  }
`;
